import Vue from "vue";
import Vuex from "vuex";
import { getToken } from "./utils/auth";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    ppinf: getToken("ppinf")
  },
  mutations: {
    SET_PPINF: (state, token) => {
      state.ppinf = token;
    }
  },
  actions: {}
});
